import React, { useState } from 'react';

import { Window } from "../../contexts"
import { Select } from "../index.jsx"

const NationalityInput = ({ ...props }) => {
    const suggestions = Window.NATIONALITIES

    return (
        <Select
            options={suggestions}
            { ...props }
        />
    )
};

export default NationalityInput;